module.exports = __webpack_public_path__ + "img/m.35a267b2.png";